import { render, staticRenderFns } from "./HrEmployeeBank.vue?vue&type=template&id=2a8ec2c8&scoped=true&"
import script from "./HrEmployeeBank.vue?vue&type=script&lang=js&"
export * from "./HrEmployeeBank.vue?vue&type=script&lang=js&"
import style0 from "./HrEmployeeBank.vue?vue&type=style&index=0&id=2a8ec2c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ec2c8",
  null
  
)

export default component.exports